import { render, staticRenderFns } from "./campus.vue?vue&type=template&id=a387949a&scoped=true&"
import script from "./campus.vue?vue&type=script&lang=js&"
export * from "./campus.vue?vue&type=script&lang=js&"
import style0 from "./campus.vue?vue&type=style&index=0&id=a387949a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a387949a",
  null
  
)

export default component.exports